import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  margin-top: 104px;

  width: 100%;
  height: calc(100% - 104px);

  overflow: auto;

  padding: 0 24px 24px 24px;

  ${({ isFooterDisplay }) =>
    isFooterDisplay &&
    css`
      height: calc(100% - 160px);
    `}
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;

  box-sizing: content-box;
  height: 40px;
  padding: 24px 24px;

  margin-left: -24px;
  margin-right: -24px;

  position: sticky;
  top: 0;
  z-index: 4;
  background-color: ${(props) => props.theme.colors.greys.lighter};
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  gap: 8px;

  :first-child {
    margin-right: 8px;
  }
`;

export const TableBorder = styled.div`
  width: 100%;
  height: 100%;

  border-radius: 8px;
  border: solid 1px ${(props) => props.theme.colors.greys.medium};

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;

export const EmptyDivContainer = styled.div`
  display: flex;
  width: 100%;
  height: 48px;
`;

export const EmptyDiv = styled.div`
  min-width: 50%;
  min-height: 100%;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const MappingContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(180px, 240px) minmax(260px, 360px) 40px;
  justify-content: start;
  align-items: center;
  gap: 8px;
`;

export const AddedLineIndicator = styled.div`
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  margin-left: -24px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.highlightedBlue};
  background-size: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('/images/inpulse/add-white-small.svg');
`;

export const InvoiceLineNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InvoiceLineTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IconButtonContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;

  flex-shrink: 0;
  border: 2px solid ${(props) => props.theme.colors.greys.darkest};
  border-radius: 8px;
  margin: auto;
  transition: 0.3s;

  &:hover {
    cursor: ${(props) => (props.isDisabled ? `not-allowed` : `pointer`)};
  }

  ${(props) =>
    props.checked
      ? css`
          background: ${props.theme.colors.brand.primary};
          border: 2px solid ${(props) => props.theme.colors.brand.primary};

          &:hover {
            border: ${!props.isDisabled && `2px solid ${props.theme.colors.greys.darker}`};
            background: ${!props.isDisabled && props.theme.colors.greys.darker};
          }
        `
      : css`
          color: ${props.theme.colors.greys.darkest};
          background: ${props.theme.colors.white};

          &:hover {
            border: ${!props.isDisabled && `2px solid ${props.theme.colors.brand.primary}`};
            background: ${!props.isDisabled && props.theme.colors.brand.primary};
          }
        `}

  ${(props) =>
    props.isDisabled &&
    css`
      background: ${props.theme.colors.greys.lighty};
      border: 2px solid ${props.theme.colors.greys.lighty};

      & img {
        filter: grayscale(1);
        opacity: 0.5;
      }
    `}

  ${(props) =>
    props.isBorderless &&
    css`
      border: none;
      background: transparent;

      &:hover {
        border: none;
        background: transparent;
      }
    `}
`;

export const IconButton = styled.img`
  width: 16px;
  height: 16px;
`;

export const PackagingListContainer = styled.div`
  position: absolute;
  width: 240px;
  top: ${(props) => (props.isLastRow ? '-42px' : '46px')};
  right: ${(props) => (props.isLastRow ? '46px' : '0px')};

  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  z-index: 10;
  background: ${(props) => props.theme.colors?.greys?.lightest};
`;

export const PackagingContainer = styled.div`
  padding: 12px 8px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => props.theme.colors?.greys?.lightest};

  &:first-child {
    border-radius: 8px 8px 0px 0px;
  }

  &:last-child {
    border-radius: 0px 0px 8px 8px;
  }

  &:only-child {
    border-radius: 8px 8px 8px 8px;
  }

  &:hover {
    background: ${(props) => props.theme.colors?.greys?.lighter};
  }
`;

export const FooterButtonsContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: end;
  gap: 16px;
`;
